import { VFC } from 'react'
import { Link } from 'react-router-dom'

import { useTranslation } from 'react-i18n-lite'
import { useActionHandler } from 'task/shared/hooks'
import { NodeModel } from 'token/shared/types'

type TaskProps = {
  nodemodel: NodeModel
  workflowUuid: string
  isActive?: boolean
  withWorkflowLink?: boolean
}

const TaskAction: VFC<TaskProps> = ({
  nodemodel,
  workflowUuid,
  isActive = true,
  withWorkflowLink = false
}) => {
  const { url, label } = useActionHandler({ nodemodel, workflowUuid })
  const { t } = useTranslation()

  const renderCurrentNodemodel = (): JSX.Element => {
    return (
      <Link to={url} className='btn btn-secondary'>
        {label}
      </Link>
    )
  }

  const renderLink = isActive && !!url

  return (
    <li className='m-2'>
      {renderLink && renderCurrentNodemodel()}

      {!renderLink && (
        <button disabled className='btn btn-secondary'>
          {nodemodel.des}
        </button>
      )}

      {withWorkflowLink && (
        <Link className='ms-2' to={`/workflow/${workflowUuid}`}>
          {t('task.go-to-workflow')}
        </Link>
      )}
    </li>
  )
}

export default TaskAction
